import * as shared from "../shared";

function useDefaultInputStyles({
  darkStyle,
  contrastStyle,
  refStyle,
  grayStyle,
  grayBorderedStyle,
  labeled,
  ...props
}) {
  const dStyleCls = darkStyle ? "darkBordered" : "";

  const cStyleCls = contrastStyle ? "contrastInput" : "";

  const rStyleCls = refStyle ? "buttonRef" : "";

  const gStyleCls = grayStyle ? "grayStyle" : "";

  const grayBorderedStyleCls = grayBorderedStyle ? "grayBordered" : "";

  const defaultClass = `${shared.defaultInputclass} ${rStyleCls} ${dStyleCls} ${grayBorderedStyleCls} ${cStyleCls} ${gStyleCls}`;

  const cName = `${defaultClass} ${props.className ? props.className : ""}`;

  if (props.href) {
    props.onClick = () => {
      window.location = props.href;
    };
  }

  return {
    ...props,
    className: cName,
  };
}

export default useDefaultInputStyles;
